import { useTranslation } from 'next-i18next'

import type { PlaylistHit } from '@/utils/algolia/autocompleteHitTypes'

import searchBoxStyles from '../../../SearchBox.module.css'
import { AutocompleteItem, HighlightedText } from '../../components'

export const PlaylistOption = ({
	item,
	activeItemId,
}: {
	item: PlaylistHit
	activeItemId: number
}): JSX.Element => {
	const { t } = useTranslation(['search'])
	const {
		value,
		imageUrl,
		availableTitles,
		url,
		__autocomplete_id: index,
	} = item

	return (
		<a
			aria-selected={activeItemId === index}
			className={searchBoxStyles.option}
			data-value={value}
			id={`${value}-listbox-option`}
			role="option"
			href={url}
			target="_blank"
			rel="noreferrer"
			data-testid="playlist-suggestion"
		>
			<AutocompleteItem
				image={{
					src: imageUrl || '',
					alt: value,
				}}
				title={<HighlightedText AlgoliaHit={item} fields={availableTitles} />}
				subtitle={t('playlist')}
				pageUrl={url}
			/>
		</a>
	)
}
